import { addDays, format } from 'date-fns'

const currentDate = new Date()
export const currentDateFormatted = format(currentDate, 'yyyy-MM-dd')

const endDate = addDays(currentDate, 6)
export const endDateFormatted = format(endDate, 'yyyy-MM-dd')

export const PROFESSIONALS_PER_PAGE = 3
